export default __webpack_public_path__ + "img/success.3768f8f.svg";